import { useSelector } from 'react-redux';

import PopupGroupContext from '~/src/components/ConnectDomruPopup/context';
import Plank from '~/src/components/PlankMobile';
import { AuthHeader } from '~/src/features/_layout/Header/AuthHeader';
import Hat from '~/src/features/_layout/Header/commonComponents/Hat';
import { UnauthHeader } from '~/src/features/_layout/Header/UnauthHeader';
import { selectHasAuthorization } from '~/src/store/selectors/auth/selectAccessToken';

import * as ST from '~/src/features/_layout/Header/styled';

const Header = (): JSX.Element => {
    const hasAuthorization = useSelector(selectHasAuthorization);

    return (
        <ST.HeaderContainer data-test='header' data-auth={hasAuthorization ? 'authorised' : 'unauthorised'} >
            <Hat/>
            <Plank/>
            {hasAuthorization
                ? <AuthHeader/>
                : <PopupGroupContext showSurvey>
                    <UnauthHeader/>
                </PopupGroupContext>
            }
        </ST.HeaderContainer>
    );
};

export default Header;
